import { useMemo } from "react";
import { createCurrencyFormatter } from "../lib/utils";
import useCurrency from "./useCurrency";

export default function useCurrencyFormatter() {
    const currency = useCurrency();
    const formatter = useMemo(() => createCurrencyFormatter(currency), [currency]);
    return (value: number) => formatter.format(value);
}